// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"body-module--wrapper--3mgzP","main":"body-module--main--1xVnK","twinkle":"body-module--twinkle--3qWkk"};